import React from "react";
import { useParams } from "react-router-dom";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import ET3PageDiv from "../../core/et3-page-div";
import Et3PageTitle from "../../core/et3-page-title/index";
import getCoreHistoryStore from "../../stores/core/core-history-store";
import KhattabatClients from "./khattabat-clients";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabatFilterstore from "../../stores/khattabat-stores/filter-store";
import { TGender } from "../../Types";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import { getKhattabaAiStore } from "../../stores/khattabat-stores/khattaba-ai-store";

const KhatabatClientsMale = withLiteObserverAndTheme(() => {
  //@ts-ignore
  const { gender } = useParams();

  React.useEffect(() => {
    const isMale = gender === "Male";
    const pageName = isMale ? `KHATTABAT_M` : `KHATTABAT_F`;
    const subPageName = isMale ? `KHATTABAT_M` : `KHATTABAT_F`;
    const genderAttribute: TGender = isMale ? "m" : "f";

    getCoreHistoryStore().setPageName(pageName, subPageName);
    const isAiKhattaba = getCorePersonalStore().isKhattabaAiAdmin.get()
    if (isAiKhattaba) {
      getKhattabaAiStore().setClients([])
      return getKhattabaAiStore().setPageGender(genderAttribute)
    }

    getKhattabatStore().setConversationsClientType("PAID");
    getKhattabatStore().getKhattabaClients({
      gender: genderAttribute,
      pageName: pageName
    });
    getKhattabatFilterstore().resetFilters();
  }, [gender]);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{ position: "relative" }}
    >
      <Et3PageTitle
        title={i18n.get("KHATTABAT")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => { }}
      />
      <KhattabatClients />
    </ET3PageDiv>
  );
});
export default KhatabatClientsMale;
